'use strict';

var _objectSpread = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/objectSpread2");

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createSuper");

var _awaitAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

var dagPb = require('@ipld/dag-pb');

var ipfsUnixfs = require('ipfs-unixfs');

var dir = require('./dir.js');

var persist = require('./utils/persist.js');

var hamtSharding = require('hamt-sharding');

var DirSharded = /*#__PURE__*/function (_dir) {
  _inherits(DirSharded, _dir);

  var _super = _createSuper(DirSharded);

  function DirSharded(props, options) {
    var _this3;

    _classCallCheck(this, DirSharded);

    _this3 = _super.call(this, props, options);
    _this3._bucket = hamtSharding.createHAMT({
      hashFn: options.hamtHashFn,
      bits: options.hamtBucketBits
    });
    return _this3;
  }

  _createClass(DirSharded, [{
    key: "put",
    value: function () {
      var _put = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(name, value) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._bucket.put(name, value);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function put(_x5, _x6) {
        return _put.apply(this, arguments);
      }

      return put;
    }()
  }, {
    key: "get",
    value: function get(name) {
      return this._bucket.get(name);
    }
  }, {
    key: "childCount",
    value: function childCount() {
      return this._bucket.leafCount();
    }
  }, {
    key: "directChildrenCount",
    value: function directChildrenCount() {
      return this._bucket.childrenCount();
    }
  }, {
    key: "onlyChild",
    value: function onlyChild() {
      return this._bucket.onlyChild();
    }
  }, {
    key: "eachChildSeries",
    value: function eachChildSeries() {
      var _this = this;

      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step$value, key, value;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _iteratorAbruptCompletion = false;
                _didIteratorError = false;
                _context2.prev = 2;
                _iterator = _asyncIterator(_this._bucket.eachLeafSeries());

              case 4:
                _context2.next = 6;
                return _awaitAsyncGenerator(_iterator.next());

              case 6:
                if (!(_iteratorAbruptCompletion = !(_step = _context2.sent).done)) {
                  _context2.next = 13;
                  break;
                }

                _step$value = _step.value, key = _step$value.key, value = _step$value.value;
                _context2.next = 10;
                return {
                  key: key,
                  child: value
                };

              case 10:
                _iteratorAbruptCompletion = false;
                _context2.next = 4;
                break;

              case 13:
                _context2.next = 19;
                break;

              case 15:
                _context2.prev = 15;
                _context2.t0 = _context2["catch"](2);
                _didIteratorError = true;
                _iteratorError = _context2.t0;

              case 19:
                _context2.prev = 19;
                _context2.prev = 20;

                if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                  _context2.next = 24;
                  break;
                }

                _context2.next = 24;
                return _awaitAsyncGenerator(_iterator.return());

              case 24:
                _context2.prev = 24;

                if (!_didIteratorError) {
                  _context2.next = 27;
                  break;
                }

                throw _iteratorError;

              case 27:
                return _context2.finish(24);

              case 28:
                return _context2.finish(19);

              case 29:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[2, 15, 19, 29], [20,, 24, 28]]);
      }))();
    }
  }, {
    key: "flush",
    value: function flush(blockstore) {
      var _this2 = this;

      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _iteratorAbruptCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, entry;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _iteratorAbruptCompletion2 = false;
                _didIteratorError2 = false;
                _context3.prev = 2;
                _iterator2 = _asyncIterator(_flush2(_this2._bucket, blockstore, _this2, _this2.options));

              case 4:
                _context3.next = 6;
                return _awaitAsyncGenerator(_iterator2.next());

              case 6:
                if (!(_iteratorAbruptCompletion2 = !(_step2 = _context3.sent).done)) {
                  _context3.next = 13;
                  break;
                }

                entry = _step2.value;
                _context3.next = 10;
                return _objectSpread(_objectSpread({}, entry), {}, {
                  path: _this2.path
                });

              case 10:
                _iteratorAbruptCompletion2 = false;
                _context3.next = 4;
                break;

              case 13:
                _context3.next = 19;
                break;

              case 15:
                _context3.prev = 15;
                _context3.t0 = _context3["catch"](2);
                _didIteratorError2 = true;
                _iteratorError2 = _context3.t0;

              case 19:
                _context3.prev = 19;
                _context3.prev = 20;

                if (!(_iteratorAbruptCompletion2 && _iterator2.return != null)) {
                  _context3.next = 24;
                  break;
                }

                _context3.next = 24;
                return _awaitAsyncGenerator(_iterator2.return());

              case 24:
                _context3.prev = 24;

                if (!_didIteratorError2) {
                  _context3.next = 27;
                  break;
                }

                throw _iteratorError2;

              case 27:
                return _context3.finish(24);

              case 28:
                return _context3.finish(19);

              case 29:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[2, 15, 19, 29], [20,, 24, 28]]);
      }))();
    }
  }]);

  return DirSharded;
}(dir);

function _flush2(_x, _x2, _x3, _x4) {
  return _flush.apply(this, arguments);
}

function _flush() {
  _flush = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(bucket, blockstore, shardRoot, options) {
    var children, links, childrenSize, i, child, labelPrefix, shard, _iteratorAbruptCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, subShard, _dir2, flushedDir, _iteratorAbruptCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, entry, label, value, _label, _size, data, dir, node, buffer, cid, size;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            children = bucket._children;
            links = [];
            childrenSize = 0;
            i = 0;

          case 4:
            if (!(i < children.length)) {
              _context4.next = 97;
              break;
            }

            child = children.get(i);

            if (child) {
              _context4.next = 8;
              break;
            }

            return _context4.abrupt("continue", 94);

          case 8:
            labelPrefix = i.toString(16).toUpperCase().padStart(2, '0');

            if (!(child instanceof hamtSharding.Bucket)) {
              _context4.next = 49;
              break;
            }

            shard = void 0;
            _iteratorAbruptCompletion3 = false;
            _didIteratorError3 = false;
            _context4.prev = 13;
            _context4.t0 = _asyncIterator;
            _context4.next = 17;
            return _awaitAsyncGenerator(_flush2(child, blockstore, null, options));

          case 17:
            _context4.t1 = _context4.sent;
            _iterator3 = (0, _context4.t0)(_context4.t1);

          case 19:
            _context4.next = 21;
            return _awaitAsyncGenerator(_iterator3.next());

          case 21:
            if (!(_iteratorAbruptCompletion3 = !(_step3 = _context4.sent).done)) {
              _context4.next = 27;
              break;
            }

            subShard = _step3.value;
            shard = subShard;

          case 24:
            _iteratorAbruptCompletion3 = false;
            _context4.next = 19;
            break;

          case 27:
            _context4.next = 33;
            break;

          case 29:
            _context4.prev = 29;
            _context4.t2 = _context4["catch"](13);
            _didIteratorError3 = true;
            _iteratorError3 = _context4.t2;

          case 33:
            _context4.prev = 33;
            _context4.prev = 34;

            if (!(_iteratorAbruptCompletion3 && _iterator3.return != null)) {
              _context4.next = 38;
              break;
            }

            _context4.next = 38;
            return _awaitAsyncGenerator(_iterator3.return());

          case 38:
            _context4.prev = 38;

            if (!_didIteratorError3) {
              _context4.next = 41;
              break;
            }

            throw _iteratorError3;

          case 41:
            return _context4.finish(38);

          case 42:
            return _context4.finish(33);

          case 43:
            if (shard) {
              _context4.next = 45;
              break;
            }

            throw new Error('Could not flush sharded directory, no subshard found');

          case 45:
            links.push({
              Name: labelPrefix,
              Tsize: shard.size,
              Hash: shard.cid
            });
            childrenSize += shard.size;
            _context4.next = 94;
            break;

          case 49:
            if (!(typeof child.value.flush === 'function')) {
              _context4.next = 87;
              break;
            }

            _dir2 = child.value;
            flushedDir = void 0;
            _iteratorAbruptCompletion4 = false;
            _didIteratorError4 = false;
            _context4.prev = 54;
            _iterator4 = _asyncIterator(_dir2.flush(blockstore));

          case 56:
            _context4.next = 58;
            return _awaitAsyncGenerator(_iterator4.next());

          case 58:
            if (!(_iteratorAbruptCompletion4 = !(_step4 = _context4.sent).done)) {
              _context4.next = 66;
              break;
            }

            entry = _step4.value;
            flushedDir = entry;
            _context4.next = 63;
            return flushedDir;

          case 63:
            _iteratorAbruptCompletion4 = false;
            _context4.next = 56;
            break;

          case 66:
            _context4.next = 72;
            break;

          case 68:
            _context4.prev = 68;
            _context4.t3 = _context4["catch"](54);
            _didIteratorError4 = true;
            _iteratorError4 = _context4.t3;

          case 72:
            _context4.prev = 72;
            _context4.prev = 73;

            if (!(_iteratorAbruptCompletion4 && _iterator4.return != null)) {
              _context4.next = 77;
              break;
            }

            _context4.next = 77;
            return _awaitAsyncGenerator(_iterator4.return());

          case 77:
            _context4.prev = 77;

            if (!_didIteratorError4) {
              _context4.next = 80;
              break;
            }

            throw _iteratorError4;

          case 80:
            return _context4.finish(77);

          case 81:
            return _context4.finish(72);

          case 82:
            label = labelPrefix + child.key;
            links.push({
              Name: label,
              Tsize: flushedDir.size,
              Hash: flushedDir.cid
            });
            childrenSize += flushedDir.size;
            _context4.next = 94;
            break;

          case 87:
            value = child.value;

            if (value.cid) {
              _context4.next = 90;
              break;
            }

            return _context4.abrupt("continue", 94);

          case 90:
            _label = labelPrefix + child.key;
            _size = value.size;
            links.push({
              Name: _label,
              Tsize: _size,
              Hash: value.cid
            });
            childrenSize += _size;

          case 94:
            i++;
            _context4.next = 4;
            break;

          case 97:
            data = Uint8Array.from(children.bitField().reverse());
            dir = new ipfsUnixfs.UnixFS({
              type: 'hamt-sharded-directory',
              data: data,
              fanout: bucket.tableSize(),
              hashType: options.hamtHashCode,
              mtime: shardRoot && shardRoot.mtime,
              mode: shardRoot && shardRoot.mode
            });
            node = {
              Data: dir.marshal(),
              Links: links
            };
            buffer = dagPb.encode(dagPb.prepare(node));
            _context4.next = 103;
            return _awaitAsyncGenerator(persist(buffer, blockstore, options));

          case 103:
            cid = _context4.sent;
            size = buffer.length + childrenSize;
            _context4.next = 107;
            return {
              cid: cid,
              unixfs: dir,
              size: size
            };

          case 107:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[13, 29, 33, 43], [34,, 38, 42], [54, 68, 72, 82], [73,, 77, 81]]);
  }));
  return _flush.apply(this, arguments);
}

module.exports = DirSharded;